import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
export const Asteriks = props => {
    return (React.createElement(SvgIcon, Object.assign({}, props),
        React.createElement("g", { transform: "translate(3.000000, 3.000000)" },
            React.createElement("polygon", { points: "11.7297297 18 10 10.5722892 15.4594595 15.4518072 18 11.2771084 10.8108108 9 18 6.72289157 15.4594595 2.54819277 10 7.37349398 11.7297297 0 6.27027027 0 8 7.37349398 2.54054054 2.54819277 0 6.72289157 7.18918919 9 0 11.2771084 2.54054054 15.4518072 8 10.5722892 6.27027027 18" }))));
};
export default Asteriks;
